export default __webpack_public_path__ + "static/media/settlement-image.bc6d0223.png";